<template>
  <span>
    <!-- 常驻的隐藏 el-image，仅作为预览容器 -->
    <el-image ref="previewImage" :src="firstUrl" :preview-src-list="fullUrls" style="display: none" />
  </span>
</template>

<script>
export default {
  name: 'ImageLook',
  props: {
    value: { type: Boolean, default: false }, // v-model
    url: { type: [Array, String], default: '' } // 字符串或数组均可
  },
  computed: {
    // 统一转换为数组并清洗
    normalizedUrls () {
      if (Array.isArray(this.url)) return this.url
      if (typeof this.url === 'string' && this.url.trim()) return [this.url.trim()]
      return []
    },
    // 生成完整可预览地址
    fullUrls () {
      const isAbsolute = u => /^(https?:\/\/|data:|blob:)/i.test(u)
      const join = (base, path) => {
        const b = String(base || '').replace(/\/+$/, '')
        const p = String(path || '').replace(/^\/+/, '')
        return `${b}/${p}`
      }

      const mapped = this.normalizedUrls
        .filter(Boolean)
        .map(u => isAbsolute(u) ? u : join(this.$baseURL, `common/service/getFile/${u}`))

      // 去重
      return Array.from(new Set(mapped))
    },
    firstUrl () {
      return this.fullUrls.length ? this.fullUrls[0] : ''
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.$nextTick(() => {
          const img = this.$refs.previewImage
          if (img && typeof img.clickHandler === 'function') {
            img.clickHandler()
          }
          // 一次性触发：弹出后复位 v-model
          this.$emit('input', false)
        })
      }
    }
  },
  methods: {
    // 如需在外部手动触发
    open () {
      this.$emit('input', true)
    }
  }
}
</script>
